export default '/src/assets/webgl/francesca/audios/global_outro.mp3'